import { Box, Link as MuiLink, useTheme } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';
import remarkGfm from 'remark-gfm';

type LegalMarkdownProps = {
  content: string;
};

export const LegalMarkdown = ({ content }: LegalMarkdownProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        maxWidth: 900,
        '& p': {
          typography: 'body1',
          color: 'text.secondary',
          lineHeight: 1.85,
          mb: 2,
        },
        '& h1': {
          typography: 'h4',
          fontWeight: 800,
          mb: 2,
          color: 'text.primary',
        },
        '& h2': {
          typography: 'h5',
          fontWeight: 700,
          mt: 4,
          mb: 1.5,
          color: 'text.primary',
        },
        '& h3': {
          typography: 'h6',
          fontWeight: 700,
          mt: 3,
          mb: 1,
          color: 'text.primary',
        },
        '& h4': {
          typography: 'subtitle1',
          fontWeight: 700,
          mt: 2,
          mb: 0.75,
        },
        '& ul, & ol': { pl: 2.5, mb: 2, color: 'text.secondary' },
        '& li': { mb: 0.5, lineHeight: 1.75 },
        '& a': { color: 'primary.main', fontWeight: 600 },
        '& strong': { color: 'text.primary' },
        '& blockquote': {
          borderLeft: `4px solid ${theme.palette.divider}`,
          pl: 2,
          my: 2,
          color: 'text.secondary',
        },
      }}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeSanitize]}
        components={{
          a: ({ href, children }) => {
            const isHttp = href?.startsWith('http');
            return (
              <MuiLink
                href={href}
                {...(isHttp
                  ? { target: '_blank', rel: 'noopener noreferrer' }
                  : {})}
                underline="hover"
              >
                {children}
              </MuiLink>
            );
          },
        }}
      >
        {content}
      </ReactMarkdown>
    </Box>
  );
};
